import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useCustomToast } from '@/shared/lib';
import { trainingMatrixApi } from '@/entities/Training';
import { useTrainingMatrixDocumentSections } from './useTrainingMatrixDocumentSections';

export const TRAINING_MATRIX_LISTING_ROUTE_NAME = 'TreinamentosMatrizTreinamentos';

export function useTrainingMatrixEditIndividual(positionId: number) {
  const toast = useCustomToast();
  const router = useRouter();
  const sections = useTrainingMatrixDocumentSections();

  const positionName = ref('');
  const loading = ref(true);
  const isSaving = ref(false);

  async function load(): Promise<void> {
    loading.value = true;
    try {
      const [current] = await Promise.all([
        trainingMatrixApi.getCurrent({ positionId, allItems: true }),
        sections.fetchAllSections(),
      ]);
      const position = current.data.positions.find((item) => item.id === positionId);
      positionName.value = position?.name ?? '';
      if (position) {
        sections.setPreselectedDocuments(position.documents);
      }
    } finally {
      loading.value = false;
    }
  }

  function goToListing(): void {
    router.push({ name: TRAINING_MATRIX_LISTING_ROUTE_NAME });
  }

  async function save(): Promise<void> {
    if (isSaving.value) return;
    isSaving.value = true;
    try {
      await trainingMatrixApi.updatePositionEntries(
        positionId,
        sections.getSelectedDocumentRevisionIds()
      );
      toast.showSuccessToast({ title: 'Matriz atualizada com sucesso', type: 'success' });
      goToListing();
    } catch {
      toast.showErrorToast({
        title: 'Erro ao atualizar matriz. Tente novamente',
        type: 'error',
      });
    } finally {
      isSaving.value = false;
    }
  }

  function cancel(): void {
    goToListing();
  }

  load();

  return {
    ...sections,
    positionName,
    loading,
    isSaving,
    save,
    cancel,
  };
}
